import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #00A651 0%, #1a1a1a 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', color: '#fff' }}>
        <img src="/logo.png" alt="Reaktor Nature Power" style={{ width: '150px', marginBottom: '20px' }} />
        <h1>Reaktor Nature Power</h1>
        <button onClick={() => navigate('/login')} className="btn btn-light mt-3">Se connecter</button>
      </div>
    </div>
  );
};

export default Home;
